import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/about-mission.webp'
import _imports_1 from '../assets/about-join-us.webp'


const _withScopeId = n => (_pushScopeId("data-v-f7314d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "first scroll-to" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "WHO WE ARE: OUR VALUES")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("p", null, " We are a group of volunteering staff and trainers around the world passionate about creating a movement of change. "),
    /*#__PURE__*/_createElementVNode("p", null, " Our global team is united in one belief that empowered women build empowered communities. "),
    /*#__PURE__*/_createElementVNode("p", null, " Our team is motivated to help impoverished women and children achieve their goals and realize their dreams. By listening to and working directly with them we make sure that our help responds to their needs. ")
  ])
], -1))
const _hoisted_2 = { class: "second scroll-to" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "OUR VISION: ONE MISSION", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("p", null, " As a team, we work tirelessly with the simple devotion to love on people. We do so in the most basic ways of using what is in our hands to create change, build better lives, restore hope, and empower people to discover their full potential and walk in the fullness of their destinies. "),
  /*#__PURE__*/_createElementVNode("p", null, "We believe in people; we believe in communities."),
  /*#__PURE__*/_createElementVNode("p", null, " Our vision is simple: Education provides knowledge which creates endless opportunities, opportunities which will pave the way to better lives. "),
  /*#__PURE__*/_createElementVNode("p", null, " By providing the right tools and education, we aspire to enable and encourage their skills in creating ventures and develop as empowered individuals. ")
], -1))
const _hoisted_6 = { class: "third scroll-to" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "WE'RE ON A MISSION: WILL YOU JOIN US?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("p", null, " Love on people staff are dedicated to empowering women and children to put their skills to work to provide for themselves and their communities. "),
  /*#__PURE__*/_createElementVNode("p", null, " We are on a mission to invest in the dreams of communities in poverty, and we want you to join us. Connect with us to know more about how you can join our team! ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_lp_sticky_button = _resolveComponent("lp-sticky-button")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("article", null, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: "/projects",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createVNode(_component_lp_button, {
                onClick: navigate,
                color: "primary",
                size: "large",
                type: "outlined"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("SEE OUR PROJECTS ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("article", null, [
        _createElementVNode("div", null, [
          _hoisted_8,
          _createVNode(_component_router_link, {
            to: "/contact",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createVNode(_component_lp_button, {
                onClick: navigate,
                size: "large",
                type: "outlined",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("GET IN TOUCH")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _hoisted_9
      ])
    ]),
    _createVNode(_component_lp_sticky_button)
  ]))
}